/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_Source_HelpInputs */



/**
* | output |
* | --- |
* | "Select the group to copy text from" |
*
* @param {Copy_Event_Text_Source_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_source_help = /** @type {((inputs?: Copy_Event_Text_Source_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_Source_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez le groupe source pour copier le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Quellgruppe zum Kopieren des Textes auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il gruppo da cui copiare il testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите группу, из которой копировать текст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione el grupo del que copiar el texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要复制文本的源组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストのコピー元グループを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट कॉपी करने के लिए स्रोत समूह चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione o grupo de onde copiar o texto")
	return /** @type {LocalizedString} */ ("Select the group to copy text from")
});